(function() {
	'use strict';
	var $ = avm.require('jquery'),
		waypoints = avm.require('avast.web.waypoints'),
		$document = $(document),
		$window = $(window),
		$graph = $('.js-graph');

// Animated graph section

	$graph.each(function(value, index) {
		var $self = $(this);

		$window.on('resize scroll', function() {
			if (waypoints($self, 0.45)) {
				$self.addClass('animate');
			}
		});
	});

})();
